<!-- 搜索框 -->
<template>
<div class="wrapper">
	<div class="search-wrapper">
		<input type="text" class="searchInput" v-model="search" @keyup="change" placeholder="搜索">
		<i class="icon iconfont icon-search" v-show="noText"></i>
		<div class="searchInput-delete" v-show="haveText" @click="del"></div>
	</div>
</div>
</template>

<script>
export default {
	 methods: {
        change () {
        	// 发送搜索事件给父组件
        	this.$emit('search-change', this.search)
        },
        del () {
            this.search= ''
            this.change()
        }
     },
     data () {
     	return {
     		search: '',
     		active: false
     	}
     },
     computed: {
        noText () {
   	      if(this.search  === '') return true
   	      return false
        },
        haveText () {
   	      if(this.search  === '') return false
   	      return true
        }
     }
}
</script>

<style lang="less" scoped>
.wrapper {
    padding: 16px 16px 12px 16px;
	.search-wrapper {
	  position: relative;
	  display: flex;
	  box-sizing: border-box;
	  height: 40px;
	  width: 100%;
	  background-color: white;
	  border: 1px solid #dee2e6;
	  border-radius: 10px;
	  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	  transition: all 0.2s ease;
	  overflow: hidden;

	  &:focus-within {
	    border-color: #007aff;
	    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
	    transform: translateY(-1px);
	  }

	  .searchInput {
	    flex: 1;
	    font-size: 14px;
	    padding: 0 12px;
	    background-color: transparent;
	    outline: none;
	    border: none;
	    font-family: 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
	    color: #212529;

	    &::placeholder {
	      color: #adb5bd;
	      font-weight: 400;
	    }
	  }

	  .icon-search {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    width: 40px;
	    height: 100%;
	    font-size: 18px;
	    color: #adb5bd;
	    transition: color 0.2s ease;

	    .search-wrapper:focus-within & {
	      color: #007aff;
	    }
	  }

	  .searchInput-delete {
	    display: block;
	    position: absolute;
	    outline: none;
	    top: 50%;
	    right: 10px;
	    width: 20px;
	    height: 20px;
	    background-color: #adb5bd;
	    border-radius: 50%;
	    cursor: pointer;
	    transition: all 0.2s ease;
	    transform: translateY(-50%);

	    &::before,
	    &::after {
	      content: '';
	      position: absolute;
	      top: 50%;
	      left: 50%;
	      width: 12px;
	      height: 2px;
	      background-color: white;
	      transform: translate(-50%, -50%) rotate(45deg);
	    }

	    &::after {
	      transform: translate(-50%, -50%) rotate(-45deg);
	    }

	    &:hover {
	      background-color: #6c757d;
	      transform: translateY(-50%) scale(1.1);
	    }
	  }
	}
}
</style>
